<template>
  <div>
    <navigation :drawer="drawer" v-if="isDesktop"></navigation>
    <navigation :drawer="drawer" v-else @close="drawer = false"></navigation>
    <v-toolbar app  height='50' scroll-off-screen>
      <v-btn icon small @click="drawer = !drawer" v-if="isMobile"><v-icon>menu</v-icon></v-btn>
      <span class="title mr-2" v-if="isDesktop">Hello, {{ user.name }}!</span>
      <span class="body-2 mr-2" v-else>{{ user.name }}!</span>
      <loading></loading>
      <v-spacer></v-spacer>
      <div class="d-flex align-center">
        <v-switch
          v-if="isDesktop"
          :label="`Dark Theme`"
          v-model="isDark"
          hide-details
        ></v-switch>
        <div class="mr-3 ml-3">
          <span class="body-2" style="display: block; text-align: center">{{ time }}</span>
          <span class="caption grey--text text--lighten-1" style="display: block; text-align: center; line-height: 1;">Europe/Kiev</span>
        </div>
      </div>
      <user></user>
    </v-toolbar>
  </div>
</template>

<script>
  import navigation from '@/components/navigation'
  import user from '@/components/toolbar/user'
  import loading from '@/components/loading'
  import {mapGetters} from "vuex";

  export default {
    name: 'Toolbar',
    data() {
      return {
        time: '',
        drawer: true,
        isDark: false,
        interval: null
      }
    },
    computed: {
      ...mapGetters(['darkTheme'])
    },
    methods: {
      getCurrentHour() {
        let currentTimeValue = new Date().toLocaleTimeString('en', {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
          timeZone: 'Europe/Kiev'
        })
        this.time =  currentTimeValue
      },
    },
    mounted() {
      this.interval = setInterval(this.getCurrentHour, 1000)
      if (this.isMobile) {
        this.drawer = false
      }
      this.isDark = this.darkTheme
    },
    beforeDestroy() {
      clearInterval(this.interval)
    },
    watch: {
      isDark(value) {
        this.$store.dispatch('changeTheme', value)
      },
    },
    components: {
      navigation,
      loading,
      user
    }
  }
</script>
